(function(global,factory){
  const api=factory();
  if(typeof module==='object'&&module.exports)module.exports=api;
  if(!global.document)return;
  const doc=global.document,key='ceika.measurement-preference.v1';
  let preference=null;
  try{const saved=global.localStorage.getItem(key);if(api.valid(saved))preference=saved;}catch(_){}
  let mode=preference||(doc.documentElement.dataset.ceikaCountry==='US'?'imperial':'metric');
  const remembered=new WeakMap();
  const scopes='[data-ceika-measurements],.ceika-product-pilot__description,.ceika-product-pilot__detail-body,.rotor-description,.coil-information,.airride-information,[data-pilot-selection],.airride-page .coil-card strong,.airride-page .coil-card small,ceika-spring-spares select,ceika-spring-spares [data-kind-text],.ceika-spares__specs,.rotor-base-field label,.rotor-base-field select,.rotor-field legend,.rotor-field .rotor-help';
  const ignored='script,style,input,textarea,[contenteditable],[data-ceika-unit-preserve]';
  function paint(scope){
    if(scope.closest(ignored))return;
    const context=scope.dataset.ceikaMeasurements||(scope.closest('ceika-rotor-configurator')?'rotor':'general');
    const walker=doc.createTreeWalker(scope,global.NodeFilter.SHOW_TEXT);
    const nodes=[];while(walker.nextNode())nodes.push(walker.currentNode);
    for(const node of nodes){
      if(node.parentElement.closest(ignored))continue;
      const previous=remembered.get(node);
      const original=previous&&node.nodeValue===previous.rendered?previous.original:node.nodeValue;
      const rendered=api.formatFor(original,mode,context);
      remembered.set(node,{original,rendered});
      if(node.nodeValue!==rendered)node.nodeValue=rendered;
    }
  }
  function scan(root=doc){
    if(root.nodeType===3)root=root.parentElement;
    if(!root?.querySelectorAll)return;
    const scope=root.closest?.(scopes);
    if(scope)paint(scope);
    else{if(root.matches?.(scopes))paint(root);root.querySelectorAll(scopes).forEach(paint);}
  }
  function controls(){
    doc.documentElement.dataset.ceikaUnits=mode;
    doc.querySelectorAll('[data-ceika-unit-select]').forEach(select=>{select.value=mode;});
  }
  function set(value,persist=true){
    if(!api.valid(value))return;
    mode=value;if(persist){preference=value;try{global.localStorage.setItem(key,value);}catch(_){}}
    controls();scan();doc.dispatchEvent(new CustomEvent('ceika:units-change',{detail:{mode}}));
  }
  global.CeikaMeasurements={get mode(){return mode;},format:(text,context)=>api.formatFor(text,mode,context),set,refresh:scan};
  doc.addEventListener('change',event=>{if(event.target.matches('[data-ceika-unit-select]'))set(event.target.value);});
  doc.addEventListener('click',event=>{if(event.target.closest('[data-ceika-unit-reset]')){preference=null;try{global.localStorage.removeItem(key);}catch(_){}set(doc.documentElement.dataset.ceikaCountry==='US'?'imperial':'metric',false);}});
  global.addEventListener('storage',event=>{if(event.key===key){preference=api.valid(event.newValue)?event.newValue:null;set(preference||(doc.documentElement.dataset.ceikaCountry==='US'?'imperial':'metric'),false);}});
  const pending=new Set();let scheduled=false;
  function flush(){scheduled=false;for(const root of pending)if(root.isConnected)scan(root);pending.clear();}
  const observer=new MutationObserver(records=>{
    for(const record of records){
      const element=record.target.nodeType===3?record.target.parentElement:record.target;
      if(element?.closest?.(scopes))pending.add(element.closest(scopes));
      for(const node of record.addedNodes||[])if(node.nodeType===1&&(node.matches(scopes)||node.querySelector(scopes)))pending.add(node);
    }
    if(pending.size&&!scheduled){scheduled=true;global.requestAnimationFrame(flush);}
  });
  controls();scan();observer.observe(doc.body||doc.documentElement,{subtree:true,childList:true,characterData:true});
})(typeof globalThis==='undefined'?this:globalThis,function(){
  const number='\\d+(?:\\.\\d+)?';
  const pattern=new RegExp('('+number+'(?:\\s*[/×x–−-]\\s*'+number+')*)\\s*(kg\\s*/\\s*mm|mm|cm|kg)(?![a-zA-Z/])','g');
  function valid(value){return value==='imperial'||value==='metric';}
  function formatFor(text,mode='metric',context='general'){
    const original=String(text??'');if(mode!=='imperial')return original;
    return original.replace(pattern,(match,values,unit,offset,whole)=>{
      if(offset&&/[A-Za-z0-9_]/.test(whole[offset-1]))return match;
      if(/(?:inches|lb\/in|lb)\s*\([^)]*$/.test(whole.slice(0,offset)))return match;
      const normalized=unit.replace(/\s/g,'');
      const pieces=values.split(/\s*([/×x–−-])\s*/);
      const numbers=pieces.filter((_,i)=>i%2===0).map(Number);
      if(numbers.some(value=>!Number.isFinite(value)||value<0))return match;
      const factor=normalized==='kg/mm'?55.997414:normalized==='kg'?2.2046226218:normalized==='cm'?1/2.54:1/25.4;
      const label=normalized==='kg/mm'?'lb/in':normalized==='kg'?'lb':'inches';
      const rotor=normalized==='mm'&&context.startsWith('rotor');
      const imperial=rotor?values.split(/\s*\/\s*/).map(part=>part.split(/[x×]/)[0].trim().replace(/\d+(?:\.\d+)?/g,value=>(Number(value)*factor).toFixed(1))).join(' / '):pieces.map((value,i)=>i%2?' '+(value==='x'?'×':value)+' ':normalized==='kg/mm'?String(Math.round(Number(value)*factor)):(Number(value)*factor).toFixed(1)).join('');
      const metric=values.replace(/\s*[x×]\s*/g,' × ')+' '+normalized;
      return imperial+' '+label+' ('+metric+')';
    });
  }
  return {valid,formatFor};
});
